/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

var _excluded = ["ariaActiveDescendant", "ariaAutoComplete", "ariaControls", "ariaDescribedBy", "ariaExpanded", "ariaLabel", "ariaLabelledBy", "ariaMultiline", "ariaOwns", "ariaRequired", "autoCapitalize", "className", "id", "role", "spellCheck", "style", "tabIndex", "data-testid"];

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

var c = require("@lexical/react/LexicalComposerContext"),
    h = require("react");

function n() {
  n = Object.assign ? Object.assign.bind() : function (g) {
    for (var d = 1; d < arguments.length; d++) {
      var e = arguments[d],
          b;

      for (b in e) {
        Object.prototype.hasOwnProperty.call(e, b) && (g[b] = e[b]);
      }
    }

    return g;
  };
  return n.apply(this, arguments);
}

var p = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement ? h.useLayoutEffect : h.useEffect;

exports.ContentEditable = function (_ref) {
  var g = _ref.ariaActiveDescendant,
      d = _ref.ariaAutoComplete,
      e = _ref.ariaControls,
      b = _ref.ariaDescribedBy,
      q = _ref.ariaExpanded,
      r = _ref.ariaLabel,
      t = _ref.ariaLabelledBy,
      u = _ref.ariaMultiline,
      v = _ref.ariaOwns,
      w = _ref.ariaRequired,
      x = _ref.autoCapitalize,
      y = _ref.className,
      z = _ref.id,
      _ref$role = _ref.role,
      l = _ref$role === void 0 ? "textbox" : _ref$role,
      _ref$spellCheck = _ref.spellCheck,
      A = _ref$spellCheck === void 0 ? !0 : _ref$spellCheck,
      B = _ref.style,
      C = _ref.tabIndex,
      D = _ref["data-testid"],
      E = _objectWithoutProperties(_ref, _excluded);

  var _c$useLexicalComposer = c.useLexicalComposerContext(),
      _c$useLexicalComposer2 = _slicedToArray(_c$useLexicalComposer, 1),
      f = _c$useLexicalComposer2[0],
      _h$useState = h.useState(!1),
      _h$useState2 = _slicedToArray(_h$useState, 2),
      a = _h$useState2[0],
      m = _h$useState2[1],
      F = h.useCallback(function (k) {
    f.setRootElement(k);
  }, [f]);

  p(function () {
    m(f.isEditable());
    return f.registerEditableListener(function (k) {
      m(k);
    });
  }, [f]);
  return h.createElement("div", n({}, E, {
    "aria-activedescendant": a ? g : void 0,
    "aria-autocomplete": a ? d : "none",
    "aria-controls": a ? e : void 0,
    "aria-describedby": b,
    "aria-expanded": a ? "combobox" === l ? !!q : void 0 : void 0,
    "aria-label": r,
    "aria-labelledby": t,
    "aria-multiline": u,
    "aria-owns": a ? v : void 0,
    "aria-readonly": a ? void 0 : !0,
    "aria-required": w,
    autoCapitalize: x,
    className: y,
    contentEditable: a,
    "data-testid": D,
    id: z,
    ref: F,
    role: l,
    spellCheck: A,
    style: B,
    tabIndex: C
  }));
};